import { Box } from "@mui/material";

export const FixedHeader = ({ logoSrc }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "80px",
        display: "flex",
        alignItems: "center",
        padding: "0 24px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        zIndex: 1200,
      }}
    >
      <Box
        component="img"
        src={"/lucro-logo-light.png"}
        alt="Lucro"
        sx={{
          width: "129.5px",
          angle: "0 deg",
          opacity: "1",
        }}
      />
    </Box>
  );
};
